<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦平台发票开具规则</div>
    <div class="main_item">
      <p>
        第一条
        为推动传统工作方式的转变和非实物服务网络交易的繁荣，保障神州邦邦平台用户合法权益，维护神州邦邦平台正常经营秩序，根据国家相关法律法规及《神州邦邦平台服务协议》制定本规则。
      </p>
    </div>
    <div class="main_item">
      <p>
        第二条
        本规则适用于所有在神州邦邦平台上进行的交易，交易包括作品买卖，服务买卖，增值服务等在神州邦邦平台上发生的交易。
      </p>
    </div>
    <div class="main_item">
      <p>第三条 开具发票的场景及主体</p>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台通过自营方式向雇主提供服务或神州邦邦平台授权并委托第三方向雇主提供服务，由神州邦邦平台向雇主开具正规发票。
          </p>
        </li>
        <li>
          <p>工程师直接承接雇主服务，由神州邦邦平台向雇主开具正规发票。</p>
        </li>
        <li>
          <p>
            在工程师直接承接雇主的服务时，神州邦邦平台为工程师提供平台技术服务并向其收取平台技术服务费，由神州邦邦平台向工程师开具正规发票。
          </p>
        </li>
        <li>
          <p>
            工程师向神州邦邦平台采购增值服务时，由神州邦邦平台向工程师开具正规发票。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>
        第四条
        对于神州邦邦平台通过自营方式承接服务或神州邦邦授权并委托第三方承接服务，在服务验收后，雇主应对订单信息及发票信息进行确认，并谨慎填写发票开票信息，神州邦邦平台开具发票类型为：增值税专用发票和增值税电子普通发票。
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            获取普通电子发票：服务验收后可在发票申请页面选择修改发票类型，选择申请“普通发票（电子）”即可。电子发票是税务局认可的有效收付款凭证，具有售后维权的法律效力，可用于单位报销使用。用户选择开具增值税电子发票后无法换取纸质的增值税普通发票，增值税电子发票与纸质增值税普通发票具有同等的法律效力。
          </p>
        </li>
        <li>
          <p>
            获取增值税专用发票：服务验收后可在发票申请页面选择修改发票类型，选择申请“增值税专用发票
            ”即可，在发票申请通过后，神州邦邦将在5个工作日内为您开具增值税专用发票。
          </p>
        </li>
      </ul>
      <p>
        开具增值税专用发票的雇主，请填写开具增值税专用发票所需信息，具体操作路径：神州邦邦App>发票申请>开发票>选择需要开票的订单>开发票。填写完毕后，为等待审核状态。
      </p>
      <p>
        注：同一时期内，在神州邦邦平台的有效增值税专用发票的开票资质仅为一个。
      </p>
    </div>
    <div class="main_item">
      <p>
        第五条
        工程师购买神州邦邦平台增值服务并由神州邦邦平台收取增值服务费的发票开具
      </p>
      <ul class="content_wrap1">
        <li>
          <p>
            平台工程师在购买神州邦邦平台的增值服务申请发票时，系统会自动获取工程师在神州邦邦平台的实名认证信息，并默认为发票开票信息，且不得修改。其中企业认证工程师可选择增值税普通电子发票和增值税专用发票，个人认证工程师默认为增值税普通电子发票。
          </p>
        </li>
        <li>
          <p>
            线下购买增值服务的新入驻工程师应及时注册平台账号，完成实名认证后申请开票。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第六条 发票信息填写的规范性要求</p>
      <ul class="content_wrap1">
        <li>
          <p>
            “开发票”页面可以修改发票类型（增值税电子普通发票、增值税专用发票）、发票抬头（个人、企业），发票抬头内容不能为空。
          </p>
        </li>
        <li>
          <p>开具增值税电子普通发票：</p>
          <p>发票抬头可选择填写个人或公司名称；</p>
          <p>发票内容系统将自动按照真实服务交易类别进行开具。</p>
        </li>
        <li>
          <p>
            开具增值税专用发票，在服务验收时需录入以下增值税专用发票资质信息：
          </p>
          <p>单位名称（必须是公司营业执照上的全称）；</p>
          <p>
            纳税人识别号（必须是公司《税务登记证》的编号，一般为18位，请仔细核对后输入）；
          </p>
          <p>注册地址（必须是公司营业执照上的注册地址）；</p>
          <p>电话（请提供能与公司保持联系的有效电话）；</p>
          <p>开户银行（必须是公司银行开户许可证上的开户银行）；</p>
          <p>银行账号（必须是公司开户许可证上的银行账号）。</p>
        </li>
        <li>
          <p>发票金额应与订单实际支付金额保持一致。</p>
        </li>
        <li>
          <p>使用优惠券的金额部分不开具发票。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第七条 关于邮寄发票说明</p>
      <ul class="content_wrap1">
        <li>
          <p>
            发票需求方在申请发票时应当认真填写邮寄地址、收件人及联系方式。若为神州邦邦平台开具发票，当您的发票金额大于1000元时无需支付快递费用；当您的发票金额小于1000元时，需要支付快递到付费用；重新生成发票的快递费用需您与神州邦邦线下沟通按情况解决。
          </p>
        </li>
        <li>
          <p>
            如发票需求方未收到发票，须发票需求方与发票开具方共同协查原因，若查实物流情况为已签收，则发票开具方不承担任何责任；若出现发票遗失情况，发票开具方应提供盖有公章的发票底联复印件或是传真，但邮寄费用须发票需求方自行承担。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第八条 增值税电子普通发票</p>
      <ul class="content_wrap1">
        <li>
          <p>
            电子发票是指在购销商品、提供或者接受服务以及从事其他经营活动中，开具、收取的以电子方式存储的收付款凭证，神州邦邦平台开具的电子发票均为真实有效的合法发票，与传统纸质发票具有同等法律效力，可作为用户维权、报销入账的有效凭据。
          </p>
        </li>
        <li>
          <p>确保电子发票具有法律效力国家发布了以下相关规定：</p>
          <p>
            2015年12月11日，中华人民共和国财政部国家档案局令第79号《会计档案管理办法》。
          </p>
          <p>
            2015年11月26日国家税务总局公告2015年第84号、2018年6月15日国家税务总局公告2018年第31号修改《关于推行通过增值税电子发票系统开具的增值税电子普通发票有关问题的公告》。
          </p>
          <p>
            2015年7月9日，税总函〔2015〕373号《关于开展增值税发票系统升级版电子发票试运行工作有关问题的通知》。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>第九条 关于不可抗力开票风险处理</p>
      <p>
        因不可抗力影响导致神州邦邦平台或神州邦邦平台指定第三方主体未按照本规则规定履行开票义务的，神州邦邦平台或神州邦邦平台指定第三方主体不承担相应的违规责任，但是应在不可抗力事件结束后及时履行开票义务。（不可抗力是指不能预见、不能避免并不能克服的客观情况。包括自然灾害、如台风、地震、洪水、冰雹；政府行为，如征收、征用；社会异常事件，如罢工、骚乱；计算机系统原因，如平台系统障碍、税务机关系统障碍等原因。）
      </p>
      <p>注意：</p>
      <ul class="content_wrap1">
        <li>
          <p>
            神州邦邦平台根据发票需求方输入的信息开具增值税专用发票，请务必认真校对所填开票信息，神州邦邦平台不会受理重新开具增值税专用发票的要求。
          </p>
        </li>
        <li>
          <p>
            发票收件人电话应填写有效的可联系的手机号码，避免使用公司号码，以免影响收票的时效性。
          </p>
        </li>
        <li>
          <p>
            一个神州邦邦平台账号只能关联一个增值税专用发票资质。增值税专用发票的内容只能按照交易服务类别开具。
          </p>
        </li>
        <li>
          <p>
            请务必确保相关信息的真实准确性，如因填写失误造成发票开具错误，将会导致发票需求方不能及时入账抵扣，带来税金损失。
          </p>
        </li>
        <li>
          <p>
            您所填写的发票邮寄地址将绑定您的账号，该账号订单所开增值税专用发票都将邮寄到该地址。如果该地址变更，请及时更新。
          </p>
        </li>
        <li>
          <p>
            发票需求方在填写发票信息时应仔细核对后提交，收到发票后应及时检查发票信息是否有误，如有误请及时与发票开具方进行沟通处理。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>